// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__CertNcamodule from "../../grpc/CertNcamodule.js";
import * as Buhta_cabinet__DocumentEdo from "../../grpc/DocumentEdo.js";
import * as Buhta_cabinet__NcaLayerConnectionErrorModal from "../Documents/Batches/NcaLayerConnectionErrorModal.js";
import * as Buhta_cabinet__NcalayerClientWrapper from "../../util/bindings/NcalayerClientWrapper.js";
import * as Buhta_cabinet__PdfCanvas from "./PdfCanvas.js";
import * as Buhta_cabinet__SignDocumentInfo from "./SignDocumentInfo.js";
import * as Buhta_cabinet__SignDropdownDesktop from "./SignDropdownDesktop.js";
import * as Buhta_cabinet__SignModal from "./SignModal.js";
import * as Buhta_cabinet__Websocket from "../../util/bindings/Websocket.js";
import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Let_syntax from "../../../../../packages/core/lib/Let_syntax.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(code) {
  return function (data) {
    const match = React.useState(function () {
          return 0;
        });
    const setActiveFile = match[1];
    const activeFile = match[0];
    const match$1 = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match$1[0];
    const match$2 = React.useState(function () {
          return false;
        });
    const setDocumentsSigned = match$2[1];
    const match$3 = React.useState(function () {
          return false;
        });
    const setSignPending = match$3[1];
    const match$4 = React.useState(function () {
          return false;
        });
    const setShowConnectionErrorModal = match$4[1];
    const match$5 = React.useState(function () {
          return false;
        });
    const setShowSignModal = match$5[1];
    const match$6 = React.useState(function () {
          
        });
    const setNcalayerClient = match$6[1];
    const ncalayerClient = match$6[0];
    const signable = Belt__Belt_List.getExn(data.signables, activeFile);
    const previewUrl = Belt__Belt_Option.getExn(signable.document).preview_url;
    const orientation = Belt__Belt_Option.getExn(signable.document).orientation;
    const onNcaLayerClick = function (param) {
      Buhta_cabinet__Websocket.make((function (ws) {
              const client = Buhta_cabinet__NcalayerClientWrapper.make(ws);
              Curry._1(setNcalayerClient, (function (param) {
                      return Caml_option.some(client);
                    }));
              Curry._1(setShowSignModal, (function (param) {
                      return true;
                    }));
            }), (function (evt) {
              Curry._1(setShowConnectionErrorModal, (function (param) {
                      return true;
                    }));
              Curry._1(setNcalayerClient, (function (param) {
                      
                    }));
            }), (function (evt) {
              Curry._1(setNcalayerClient, (function (param) {
                      
                    }));
            }), "wss://127.0.0.1:13579");
    };
    const signDocs = function (param) {
      Curry._1(setSignPending, (function (param) {
              return true;
            }));
      return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__DocumentEdo.PublicSignService.listSignDocuments(undefined, code, undefined), (function (result) {
                    if (result.TAG === /* Ok */0) {
                      const documents = Belt__Belt_List.map(result._0, (function (doc) {
                              const match = doc.sign_document;
                              let tmp;
                              let exit = 0;
                              if (typeof match === "string") {
                                exit = 1;
                              } else {
                                const variant = match.NAME;
                                if (variant === "Xml_document") {
                                  tmp = {
                                    NAME: "Xml",
                                    VAL: Curry._2(Buhta_cabinet__CertNcamodule.Signable.xml, match.VAL, undefined)
                                  };
                                } else if (variant === "File_document") {
                                  const match$1 = match.VAL.file;
                                  if (match$1 !== undefined) {
                                    tmp = {
                                      NAME: "File",
                                      VAL: Curry._5(Buhta_cabinet__CertNcamodule.Signable.file, match$1.data, undefined, match$1.mime, undefined, undefined)
                                    };
                                  } else {
                                    exit = 1;
                                  }
                                } else {
                                  exit = 1;
                                }
                              }
                              if (exit === 1) {
                                tmp = {
                                  NAME: "Xml",
                                  VAL: Curry._2(Buhta_cabinet__CertNcamodule.Signable.xml, "", undefined)
                                };
                              }
                              return Curry._4(Buhta_cabinet__CertNcamodule.Signable.make, doc.id, Belt__Belt_List.map(doc.metadata, (function (param) {
                                                return Curry._3(Buhta_cabinet__CertNcamodule.Signable.metadata, param.name, param.value, undefined);
                                              })), tmp, undefined);
                            }));
                      const participant = Belt__Belt_Option.getExn(signable.participant);
                      const request = Buhta_cabinet__CertNcamodule.RpcBulkSignDocument.makeInitialRequest(participant.tin, documents, undefined, undefined);
                      const client = Belt__Belt_Option.getExn(ncalayerClient);
                      return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__CertNcamodule.NcamoduleClient.bulkSign(client, request), (function (result) {
                                    if (result.TAG === /* Ok */0) {
                                      const signed = Belt__Belt_List.map(result._0.documents, (function (doc) {
                                              const match = doc.document;
                                              return Curry._4(Buhta_cabinet__DocumentEdo.DocumentSign.make, Belt__Belt_Option.getExn(doc.id), undefined, typeof match === "string" ? ({
                                                              NAME: "Xml_document",
                                                              VAL: ""
                                                            }) : (
                                                            match.NAME === "File" ? ({
                                                                  NAME: "File_document",
                                                                  VAL: {
                                                                    data: match.VAL.data,
                                                                    attached: false
                                                                  }
                                                                }) : ({
                                                                  NAME: "Xml_document",
                                                                  VAL: match.VAL.data
                                                                })
                                                          ), undefined);
                                            }));
                                      return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__DocumentEdo.PublicSignService.bulkSign(tenant, signable.hash, signed, undefined), (function (result) {
                                                    if (result.TAG === /* Ok */0) {
                                                      Curry._1(setDocumentsSigned, (function (param) {
                                                              return true;
                                                            }));
                                                      return Curry._1(setSignPending, (function (param) {
                                                                    return false;
                                                                  }));
                                                    }
                                                    console.log("error", result._0);
                                                    Curry._1(setSignPending, (function (param) {
                                                            return false;
                                                          }));
                                                  }));
                                    }
                                    console.log("error", result._0);
                                    Curry._1(setSignPending, (function (param) {
                                            return false;
                                          }));
                                    return $$Promise.resolved(undefined);
                                  }));
                    }
                    Curry._1(setSignPending, (function (param) {
                            return false;
                          }));
                    return $$Promise.resolved($$Promise.resolved(undefined));
                  }));
    };
    const match$7 = Belt__Belt_Option.getExn(signable.participant).sign_status;
    const __x = data.signables;
    const doc = signable.document;
    let tmp;
    if (doc !== undefined) {
      const participant = signable.participant;
      tmp = participant !== undefined ? JsxRuntime.jsx(Buhta_cabinet__SignDocumentInfo.make, {
              doc: doc,
              participant: participant
            }) : null;
    } else {
      tmp = null;
    }
    return JsxRuntime.jsxs(React.Fragment, {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "w-20 h-5",
                                                alt: "buhta",
                                                src: StaticAsset.src("/static/icons/logo-black-80.svg")
                                              }),
                                          JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                                className: "ml-10",
                                                children: Belt__Belt_Option.getExn(signable.document).name
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "text-gray-medium",
                                                      children: match$7 >= 2 ? "Подписан" : "Не подписан"
                                                    }),
                                                className: "px-3 py-0.5 bg-gray-pale rounded-3xl ml-2"
                                              })
                                        ],
                                        className: "flex items-center"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: match$2[0] ? JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                                        className: "text-default-gray",
                                                        children: "Вы подписали документы"
                                                      }),
                                                  JsxRuntime.jsx("img", {
                                                        className: "w-4 h-4",
                                                        alt: "sign",
                                                        src: StaticAsset.src("/static/icons/sign-green-16.svg")
                                                      })
                                                ],
                                                className: "flex items-center bg-gray-main gap-1 px-3 py-2 rounded ml-10"
                                              }) : JsxRuntime.jsx(Buhta_cabinet__SignDropdownDesktop.make, {
                                                title: "Подписать все документы",
                                                code: code,
                                                onNcaLayerClick: onNcaLayerClick
                                              }),
                                        className: "flex items-center"
                                      })
                                ],
                                className: "px-6 py-3 flex items-center justify-between border-b border-gray-main bg-white"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                children: "Документов: " + String(Belt__Belt_List.length(data.signables))
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, signable) {
                                                            const $$document = signable.document;
                                                            if ($$document === undefined) {
                                                              return null;
                                                            }
                                                            const Key = "signable-" + String(index);
                                                            const match = $$document.source_type;
                                                            const match$1 = activeFile === index;
                                                            let tmp = match === "pdf_file" ? (
                                                                match$1 ? "/static/icons/file-pdf-white-24.svg" : "/static/icons/file-pdf-gray-24.svg"
                                                              ) : (
                                                                match$1 ? "/static/icons/file-doc-white-24.svg" : "/static/icons/file-doc-gray-24.svg"
                                                              );
                                                            return JsxRuntime.jsxs("button", {
                                                                        children: [
                                                                          JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("img", {
                                                                                      className: "w-6 h-6",
                                                                                      alt: "file-pdf",
                                                                                      src: StaticAsset.src(tmp)
                                                                                    }),
                                                                                className: "flex justify-between w-full"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                                                className: activeFile === index ? "text-white" : "text-asphalt",
                                                                                children: $$document.name
                                                                              })
                                                                        ],
                                                                        className: Cn.fromList({
                                                                              hd: "rounded-md px-2 py-3 shadow-kkms w-full space-y-4 border border-gray-main flex flex-col justify-between shrink-0 min-h-[214px]",
                                                                              tl: {
                                                                                hd: activeFile === index ? "bg-asphalt-dark" : "",
                                                                                tl: /* [] */0
                                                                              }
                                                                            }),
                                                                        onClick: (function (param) {
                                                                            Curry._1(setActiveFile, (function (param) {
                                                                                    return index;
                                                                                  }));
                                                                          })
                                                                      }, Key);
                                                          }))),
                                                className: "flex flex-col gap-4 overflow-auto"
                                              })
                                        ],
                                        className: "w-50 bg-white border-t border-gray-main p-6 space-y-4 z-2 shrink-0 overflow-auto"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_cabinet__PdfCanvas.make, {
                                                    multi: true,
                                                    hash: signable.hash,
                                                    previewUrl: previewUrl,
                                                    orientation: orientation
                                                  }),
                                              className: "mt-10"
                                            }),
                                        className: "overflow-auto w-full"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: tmp,
                                        className: "bg-white w-[354px] p-6 border-r border-gray-main shrink-0"
                                      })
                                ],
                                className: "flex flex-1 overflow-auto"
                              })
                        ],
                        className: "h-screen bg-gray-pale flex flex-col"
                      }),
                  match$3[0] ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {
                                primaryColor: "border-white"
                              }),
                          className: "absolute inset-0 bg-black/40 flex justify-center items-center z-10"
                        }) : null,
                  match$4[0] ? JsxRuntime.jsx(Buhta_cabinet__NcaLayerConnectionErrorModal.make, {
                          onClose: (function (param) {
                              Curry._1(setShowConnectionErrorModal, (function (param) {
                                      return false;
                                    }));
                            })
                        }) : null,
                  match$5[0] ? JsxRuntime.jsx(Buhta_cabinet__SignModal.make, {
                          onClose: (function (param) {
                              Curry._1(setShowSignModal, (function (param) {
                                      return false;
                                    }));
                            }),
                          onSignClicked: (function (param) {
                              signDocs(undefined);
                              Curry._1(setShowSignModal, (function (param) {
                                      return false;
                                    }));
                            }),
                          participant: Belt__Belt_Option.getExn(signable.participant)
                        }) : null
                ]
              });
  };
}

function SignFlowDesktopMulti2(Props) {
  return make(Props.code)(Props.data);
}

const make$1 = SignFlowDesktopMulti2;

export {
  make$1 as make,
}
/* Buhta_cabinet__CertNcamodule Not a pure module */
